"use client";

import { MapPin } from "lucide-react";
import { useCallback, useState } from "react";

import { StateSelectorDialog } from "@/app/(discover)/components/state-selector/state-selector-dialog";
import { Button } from "@/components/ui/button";
import { stateSelectorDataTestIds } from "@/lib/data-test-ids/state-selector.data-test-ids";
import { type StateConfig } from "@/lib/states-config";
import { usePreserveFilters } from "@/stores/use-preserve-filters";

export interface StateDropdownProps {
  currentState: StateConfig;
}

export default function StateDropdown({ currentState }: StateDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { clearPreservedFilters } = usePreserveFilters();

  const closeFn = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const selectFn = useCallback(() => {
    clearPreservedFilters();
    closeFn();
  }, [closeFn, clearPreservedFilters]);

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setIsOpen(true)}
        className="px-2 sm:px-3 h-8 sm:h-9 font-medium text-xs sm:text-sm text-ink-emphasis "
        title="Switch job board"
        data-testid={stateSelectorDataTestIds.TRIGGER_BUTTON}
      >
        <MapPin className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span className="sm:hidden">{currentState.abbreviation}</span>
        <span className="hidden sm:inline">{currentState.title}</span>
      </Button>

      <StateSelectorDialog
        isOpen={isOpen}
        onClose={closeFn}
        onSelect={selectFn}
        currentState={currentState}
      />
    </>
  );
}
